import { TooltipProps } from './Tooltip.typed';
import { BaseTooltip } from './BaseTooltip/BaseTooltip';
import * as Styled from './Tooltip.styled';
import { FloatingPortal } from '@floating-ui/react';
import { forwardRef, useId } from 'react';

export const TooltipComponent = forwardRef<HTMLDivElement, TooltipProps>(
  ({ arrowRef, children, context, role = 'tooltip', ...rest }, ref) => {
    const id = useId();
    return (
      <FloatingPortal>
        {context.open && (
          <div {...rest} ref={ref} role={role} id={id}>
            <BaseTooltip>
              {children}
              <Styled.TooltipArrow
                tipRadius={3}
                height={8}
                context={context}
                ref={arrowRef}
              />
            </BaseTooltip>
          </div>
        )}
      </FloatingPortal>
    );
  },
);

export const Tooltip = TooltipComponent as typeof TooltipComponent & {
  Header: typeof BaseTooltip.Header;
  Body: typeof BaseTooltip.Body;
};

Tooltip.Header = BaseTooltip.Header;
Tooltip.Body = BaseTooltip.Body;

export default Tooltip;
